module.exports = __webpack_public_path__ + "dashboard/img/photo-film-music.34243aa9862bafb13c5d8963719897cb.svg";